import { InstallmentViewModel } from '@api/index';

export const getInstallmentPrices = (
  installments: InstallmentViewModel[],
  installmentNumber: number
) => {
  const targetInstallment = installments?.find(
    (installment) =>
      installment.count + (installment.additionalInstallmentCount || 0) ===
      installmentNumber
  );
  return {
    price: targetInstallment?.price ?? 0,
    totalPrice: targetInstallment?.totalPrice ?? 0,
  };
};
